module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1onedynastytransformedintoafemaleemperor"
    }
  }, [_vm._v("CHAPTER 1 - ONE DYNASTY TRANSFORMED INTO A FEMALE EMPEROR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2stumbleagainsttheking"
    }
  }, [_vm._v("CHAPTER 2 - STUMBLE AGAINST THE KING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/2_chapter3theelderlingsarecurioustointerrogatethevassals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3 - THE ELDERLINGS ARE CURIOUS TO INTERROGATE THE VASSALS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/3_chapter4herosadbeautypass",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4 - HERO SAD BEAUTY PASS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/4_chapter5fifteencupsofspringwater",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 - FIFTEEN CUPS OF SPRING WATER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/5_chapter6thequeenoftravelingwiththearmy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - THE QUEEN OF TRAVELING WITH THE ARMY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/6_chapter7sandwolfshowingmysteriouslife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - SAND WOLF SHOWING MYSTERIOUS LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/7_chapter8siriusinthehighmorage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - SIRIUS IN THE HIGH MO RAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter9howmanygenerationsofpreviouslovedebthavebeenrepaid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - HOW MANY GENERATIONS OF PREVIOUS LOVE DEBT HAVE BEEN REPAID")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10soloveissobroken",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - SO LOVE IS SO BROKEN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11sowhatifhediedlikethis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - SO WHAT IF HE DIED LIKE THIS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12thepastisalongstory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - THE PAST IS A LONG STORY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13thepurpleskyisstillcomingoutbutitsstillbreakingdown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - THE PURPLE SKY IS STILL COMING OUT BUT IT'S STILL BREAKING DOWN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14istartwithtwothings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - I START WITH TWO THINGS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15meetingthekingofhellinnanluotown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - MEETING THE KING OF HELL IN NANLUO TOWN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16threemenforaplay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - THREE MEN FOR A PLAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17mutationineverythingregretsintestinalregrets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - MUTATION IN EVERYTHING REGRETS INTESTINAL REGRETS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18astormisbrewing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - A STORM IS BREWING")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0